import { useState, useEffect } from "react";
import { Users, FolderOpen, MessageSquare, Lightbulb } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const statCards = [
  { key: "users", label: "Total Users", icon: Users, color: "from-blue-600 to-blue-400" },
  { key: "projects", label: "Projects", icon: FolderOpen, color: "from-cyan-500 to-cyan-400" },
  { key: "pending_requests", label: "Pending Requests", icon: MessageSquare, color: "from-amber-500 to-amber-400" },
  { key: "ideas", label: "Ideas", icon: Lightbulb, color: "from-emerald-500 to-emerald-400" },
];

export default function AdminDashboard() {
  const { api } = useAuth();
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/stats")
      .then((r) => setStats(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  return (
    <div data-testid="admin-dashboard-page">
      <div className="mb-8">
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-slate-400 mb-2">Administration</p>
        <h1 className="font-serif text-3xl font-bold text-slate-900 tracking-tight">Dashboard</h1>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><div className="spinner"></div></div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {statCards.map((card) => (
            <div key={card.key} className="bg-white border border-slate-200 rounded-xl p-6" data-testid={`stat-${card.key}`}>
              <div className={`w-10 h-10 rounded-lg bg-gradient-to-r ${card.color} flex items-center justify-center mb-4`}>
                <card.icon className="w-5 h-5 text-white" />
              </div>
              <p className="font-mono text-3xl font-bold text-slate-900">{stats[card.key] ?? 0}</p>
              <p className="font-sans text-sm text-slate-500 mt-1">{card.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
